import React from "react";
import CheckboxGroup from "../../CheckboxGroup";
import { Box } from "@mui/material";

const FloweringTime = ({ value, onChange }) => {
  const options = ["Summer", "Autumn", "Winter", "Spring"];

  const handleFloweringTimeChange = (selectedOptions) => {
    onChange(selectedOptions);
  };

  return (
    <Box>
      <CheckboxGroup
        title={"Flowering Time"}
        options={options}
        selectedOptions={value}
        onChange={handleFloweringTimeChange}
      />
    </Box>
  );
};

export default FloweringTime;
